import { PVADiamond, PVAStyleBreakdown } from '../reports/blocks';
import { Tab, Tabs } from 'react-bootstrap';
import { Style, StyleText } from '../../models';
import * as React from 'react';
import { NotificationService } from '../../services';
import { PonderaModal } from './PonderaModal';

interface StyleContentProps {
    style: Style;
    name: string;
    notificationService: NotificationService;
    exporting: boolean;
    onExport?: Function;
    sortedAdditionalStyles: StyleText[];
    asModal: boolean;
    title?: string;
    onHide?: Function;
}

interface StyleContentState {
}

export class PVAStyleContent extends React.Component<StyleContentProps, StyleContentState> {
    render(): any {
        let content = (type: string) => {
            var result = this.props.style.styleTexts.find((st: StyleText) => {
                return st.styleTextType === type;
            });
            if (result) {
                return result.value;
            }
            return '';
        };

        let containerClasses = 'modal-container pva-style-modal';
        let dialogClasses = 'modal-dialog';
        let contentClasses = 'modal-content';
        let headerClasses = 'modal-header pva-group-title pondera-modal-header';
        let headerDiamondClasses = 'modal-header-diamond';
        let modalTitleClasses = 'modal-title';
        let modalBodyClasses = 'modal-body';
        let modalContentContainerClasses = 'modal-content-container';
        let modalFooterClasses = 'modal-footer';
        let ponderaModalTitleClasses = 'pondera-modal-title';
        let ponderaModalSubTitleClasses = 'pondera-modal-sub-title';
        let widthClasses = 'col-xs-offset-1 col-xs-10 col-sm-offset-2 col-sm-8';
        let hashBoxContainer = 'hash-box-container';
        if (!this.props.asModal) {
            headerClasses = '';
            containerClasses = 'content-container';
            dialogClasses = '';
            widthClasses = '';
            contentClasses = '';
            modalBodyClasses = 'style-content-body-container';
            hashBoxContainer = 'hash-box-container limited-report-hash-box-container';
        }

        let button = (
            <button type="button" className="close pondera-close" onClick={(e) => this.props.onHide!()}>
                <span className="glyphicon glyphicon-remove" />
                <span className="sr-only">Close</span>
            </button>
        );

        let header = (
            <div id={this.props.title} className={headerClasses}>
                {this.props.asModal && button}
                <div className={headerDiamondClasses}>
                    <PVADiamond style={this.props.style.name} step={4} />
                </div>
                <div className={modalTitleClasses}>
                    {this.props.name !== ' ' && <div>
                        <div className={ponderaModalSubTitleClasses}>PVA Style for</div>
                        <div className={ponderaModalTitleClasses}>{this.props.name}</div>
                    </div>}
                    {this.props.name === ' ' && <div>
                        <div className={ponderaModalSubTitleClasses} />
                        <div className={ponderaModalTitleClasses}>PVA Style</div>
                    </div>}
                </div>
            </div>
        );
        if (!this.props.asModal) {
            header = (
                <div />
            );
        }

        let footer = (
            <div className={modalFooterClasses}>
                {this.props.exporting && <button disabled={true} type="button" className="btn btn-primary">Generating...</button>}
                {!this.props.exporting && <button onClick={(e) => this.props.onExport!()} type="button" className="btn btn-primary">Export PDF</button>}
                <button onClick={(e) => this.props.onHide!()} type="button" className="btn btn-default">Close</button>
            </div>
        );

        let breakdown = (
            <div>
                <PVAStyleBreakdown style={this.props.style} name={' '} brief={content('brief')} content={content('content')} showSecondaryStyle={!this.props.asModal} />
            </div>
        );

        return (
            <div className={containerClasses}>
                <div className="row">
                    <div className={widthClasses}>
                        <div className={dialogClasses}>
                            <div className={contentClasses} role="document">
                                {header}
                                <Tabs defaultActiveKey="summary">
                                    {!this.props.asModal && breakdown}
                                    <Tab eventKey="summary" title="Summary">
                                        <div className={modalBodyClasses}>
                                            {this.props.asModal && breakdown}
                                            <div dangerouslySetInnerHTML={{ __html: content('top')}} />
                                            <div style={{border: 0, width: '100%'}}>
                                                <div className={hashBoxContainer}>
                                                    <div>
                                                        <div className={modalContentContainerClasses}>
                                                            <div>
                                                                <div dangerouslySetInnerHTML={{ __html: content('left')}} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className={modalContentContainerClasses}>
                                                            <div>
                                                                <div dangerouslySetInnerHTML={{ __html: content('right')}} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div dangerouslySetInnerHTML={{ __html: content('bottom')}} />
                                            <div dangerouslySetInnerHTML={{ __html: content('team')}} />
                                        </div>
                                    </Tab>
                                    {this.props.sortedAdditionalStyles.map((styleText: StyleText, ind: number) => {
                                        return <Tab key={styleText.keyName} eventKey={styleText.keyName} title={styleText.keyName}>
                                            <div className={modalBodyClasses}>
                                                <div key={styleText.value} dangerouslySetInnerHTML={{ __html: styleText.value}}/>
                                            </div>
                                        </Tab>;
                                    })}
                                </Tabs>
                                {this.props.asModal && footer}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/inclinationmodals/PVAStyleContent.tsx